import React, { memo, forwardRef } from "react";
const SvgMinusplus = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeWidth={2}
        d="M16 26V12M23 19H9M23 7H9"
      />
    </svg>
  );
});
SvgMinusplus.displayName = "SvgMinusplus";
const MemoForwardRef = memo(SvgMinusplus);
export default MemoForwardRef;
